import type { LogFn } from "pino";

import { initLogging } from "@expert/logging";
import { getFullStoryUrlSync } from "@expert/monitoring";

import { env } from "@/config";

function sendRuntimeErrorMetric(_args: Parameters<LogFn>): void {
    // Lazy import: sendMetrics calls getLogger at module load, which requires initLogging first.
    void import("@expert/cloudwatch-metrics").then(({ sendEventMetric }) => {
        void sendEventMetric("RuntimeErrorLogged");
    });
}

initLogging({
    appName: env.appName,
    commitHash: env.commitHash,
    logLevel: env.logLevel,
    channel: env.channel,
    isConsoleLogEnabled: !env.disableConsoleLogs,
    mixin: () => ({ fullStoryUrl: getFullStoryUrlSync() ?? "not defined" }),
    onError: sendRuntimeErrorMetric,
});
